import { requestConstantsMaker } from '../helper';

export const GET_ALL_STUDENT = requestConstantsMaker('GET_ALL_STUDENT');
export const GET_STUDENT = requestConstantsMaker('GET_STUDENT');
export const CREATE_STUDENT = requestConstantsMaker('CREATE_STUDENT');
export const UPDATE_STUDENT = requestConstantsMaker('UPDATE_STUDENT');
export const GET_STUDENTS_FOR_SELECTION = requestConstantsMaker('GET_STUDENTS_FOR_SELECTION');